import { observer } from "mobx-react-lite"
import Layout from "../../components/layout/Layout"
import { useStore } from "../../stores/root-store-context";
import { Button, Flex, Form, Spin, App, Card, TabsProps, UploadFile, AutoComplete } from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Project } from "../../stores/ProjectsStore";
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/js/plugins.pkgd.min.js';
import { useTranslation } from "react-i18next";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';


const Kanban = observer(({ isEditMode }: { isEditMode: boolean }) => {
    const [form] = Form.useForm();
    const { message } = App.useApp();
    const { t } = useTranslation();

    const navigate = useNavigate();
    const { id, documentId } = useParams();

    const { applicationStore, projectsStore, projectDocumentationStore } = useStore();

    const [project, setProject] = useState<Project>();
    const [documents, setDocuments] = useState<TabsProps['items']>([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isExporting, setIsExporting] = useState(false);

    const [currentTab, setCurrentTab] = useState("");
    const [currentFileList, setCurrentFileList] = useState<any[]>([]);

    const [editorContent, setEditorContent] = useState('');

    const [fileConflictData, setFileConflictData] = useState<{ file: UploadFile, id: string } | null>(null);

    const [isEditorReady, setIsEditorReady] = useState(false);





    useEffect(() => {
        if (!isModalOpen) {
            setIsEditorReady(false);
        }
    }, [isModalOpen]);


    return (
        <Layout headerStyle={1} footerStyle={2} breadcrumbTitle={`Kanban`}>
            <div className="container" style={{ margin: "20px auto" }}>
                <Spin spinning={false}>
                    <Card style={{ margin: "20 0", textAlign: "center" }}>
                        <Flex justify="space-between">
                            <Button type="primary"
                                style={{ float: "right", marginBottom: 20, borderRadius: 0 }}
                                onClick={() => {
                                    navigate(`/${applicationStore.company?.Tenant}/projects`);
                                }}>
                                {t("Back")}
                            </Button>
                            <AutoComplete
                        style={{ height: 40, width: 400, margin: "10px 0" }}
                        placeholder="Project"
                        options={projectsStore.projects
                            .filter(
                                (project) =>
                                    project.isActive !== false && (project.isPublish ||
                                        project.developers.some(
                                            (el) => el.id == applicationStore.user.id
                                        ))
                            )
                            ?.map((el, index) => ({
                                value: el.title,
                                label: (
                                    <Flex gap={5}>
                                        <span>{`${el.title}`}</span>
                                    </Flex>
                                ),
                                data: el,
                            }))}
                        onChange={(value, option: any) => {
                            form.setFieldValue("projectId", option.data?.id);

                            const description = form.getFieldValue("description");

                            if (option?.data?.title && !description || description === "") {
                                form.setFieldValue(
                                    "description",
                                    t("WorkOnProject", { projectTitle: option.data.title || "" })
                                );
                            }
                        }}
                        filterOption={(inputValue, option) => {

                            return (
                                option?.value
                                    .toUpperCase()
                                    .indexOf(inputValue.toUpperCase()) !== -1
                            );
                        }}

                    />
                        </Flex>

                    </Card>
                   
                </Spin>
            </div>

        </Layout >
    )
})
export default Kanban;